import { TableCell, TableRow } from '@material-ui/core';
import { SentCode } from '@nemuru-eng/js-api-client';

import { useOtpTable } from '@/components/modules/KYC/KYCOrder/components/Otp/hooks/useOtpTable';
import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';

interface OtpTableBodyProps {
  sentCodesToRecipient: SentCode[];
}

export const OtpTableBody = ({ sentCodesToRecipient }: OtpTableBodyProps) => {
  const { classes, columns } = useOtpTable();

  return (
    <>
      {sentCodesToRecipient
        .sort((a, b) => (a.date.getTime() > b.date.getTime() ? 1 : -1))
        .map((sentCode) => {
          return (
            <TableRow key={sentCode.providerId} className={classes.root}>
              <TableCell align={'left'}>
                <Font variant={'body2'} color={'textPrimary'}>
                  <Text tId={sentCode.code} />
                </Font>
              </TableCell>
              <TableCell align={'left'}>
                <Font variant={'body2'} color={'textPrimary'}>
                  <Text tId={sentCode.status} />
                </Font>
              </TableCell>
              {columns.some((column) => column.name === 'providerName') && (
                <TableCell align={'left'}>
                  <Font variant={'body2'} color={'textPrimary'}>
                    <Text tId={sentCode.providerName} />
                  </Font>
                </TableCell>
              )}
              <TableCell align={'right'}>
                <Font variant={'body2'} color={'textPrimary'}>
                  {`${sentCode.date.toLocaleDateString()} ${sentCode.date.toLocaleTimeString()}`}
                </Font>
              </TableCell>
            </TableRow>
          );
        })}
    </>
  );
};
